import axios, { AxiosError } from 'axios';
import { UserSettingsPutRequest } from 'src/models/userSettingsPutRequest';
import { getSimManagementErrorFromAxiosError } from '.';
import config from '../config';
import { UserSettings } from '../models/state/userSettings';

export function getById(userId: string): Promise<UserSettings> {
  const url = config.API_BASE_URL + `api/userSettings/${userId}`;
  return new Promise<UserSettings>((resolve, reject) => {
    axios
      .get(url)
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error);
        reject(simManagementError);
      });
  });
}

export function put(putRequest: UserSettingsPutRequest): Promise<UserSettings> {
  return new Promise<UserSettings>((resolve, reject) => {
    axios
      .put(`${config.API_BASE_URL}api/userSettings/${putRequest.userId}`, putRequest.userSettings)
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error);
        reject(simManagementError);
      });
  });
}

export function remove(userId: string, userSettingsNames?: Array<string>): Promise<UserSettings> {
  return new Promise<UserSettings>((resolve, reject) => {
    axios({ method: 'delete', url: `${config.API_BASE_URL}api/userSettings/${userId}`, data: userSettingsNames || [] })
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error);
        reject(simManagementError);
      });
  });
}

export function getTheme(userId: string, companyId: number | null, accountId: number | null): Promise<Record<string, string>> {
  let url = config.API_BASE_URL + `api/user/${userId}/theme?companyId=${companyId}&accountId=${accountId}`;
  return new Promise<Record<string, string>>((resolve, reject) => {
    axios
      .get(url)
      .then((reply: any) => {
        let settings = reply.data as Record<string, string>;
        resolve(settings);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        reject(simManagementError);
      });
  });
}
